import { Injectable } from '@angular/core';
import { PdfmakeService } from './pdfmake/pdfmake.service';
import { RegistrosService } from './API/registros/registros.service';
import { NotificationServiceService } from './notification-service/notification-service.service';

@Injectable({
  providedIn: 'root'
})
export class GenerarDocumentoService {

  /** Hueco foto principal en PDF (pt, proporción 4:3). */
  private readonly pdfPhotoW = 400;
  private readonly pdfPhotoH = 300;
  /** Hueco fotos dobles de clasificación. */
  private readonly pdfPhotoSmallW = 185;
  private readonly pdfPhotoSmallH = 139;
  /** Margen superior común foto + tabla en la misma fila. */
  private readonly pdfContentTopMargin = 20;

  constructor(private pdfmake: PdfmakeService, private registrosService: RegistrosService, private notificationService: NotificationServiceService) { }

  generarDoc(albaran: string, data: any, resumen: any, clasificado: boolean) {
    // Conseguimos el numero de impresion en PDF
    this.registrosService.getNumImpresion().subscribe(result => {
      if(result['status'] === 'ok') {
        //console.log(result['impresion']);
        this.guardarDoc(albaran, data, result['impresion'], resumen, clasificado);
      }else{
        this.notificationService.openSnackBar("¡ERROR: No se ha podido generar el documento!");
      }
    });
  }

  guardarDoc(albaran: string, data: any, numeroImpresion: string, resumen: any, clasificado: boolean) {

    var bloquesText = [];

    // GENERAMOS LAS PAGINAS
    for(var i=0; i<data.length; i++){

      if(i > 0){
        bloquesText.push(
          {
            text: '',
            pageBreak: "before"
          }
        );
      }

      bloquesText.push({
        columns: [
          {
            width: 180,
            image: this.topLogo,
            alignment : 'center'
          },
          {
            width: '*',
            alignment: 'center',
            text: [
              {text: 'DOCUMENTO DE BÁSCULA', color: '#0075BD', bold: true, fontSize: 23},
            ]
            , margin: [50, 10, 0, 0]
          }
        ]
      });

      bloquesText.push({ text: [
        {text: 'Albarán ' + albaran, color: '#595959', fontSize: 20, bold: true},
        {text: ' - Peso #' + (i+1), color: '#595959', fontSize: 20, bold: true},
      ], margin: [0, 10, 0, 0]});

      bloquesText.push(
        this.pdfPhotoTableRow(
          data[i]['foto'],
          this.pdfPhotoW,
          this.pdfPhotoH,
          this.buildPesajeTable(data[i]),
        ),
      );
    }

    // RESUMEN DE PESOS
    bloquesText.push(
      {
        text: '',
        pageBreak: "before"
      }
    );

    bloquesText.push({
      columns: [
        {
          width: 180,
          image: this.topLogo,
          alignment : 'center'
        },
        {
          width: '*',
          alignment: 'center',
          text: [
            {text: 'DOCUMENTO DE BÁSCULA', color: '#0075BD', bold: true, fontSize: 23},
          ]
          , margin: [50, 10, 0, 0]
        }
      ]
    });

    bloquesText.push({ text: [
      {text: 'Resumen pesos - Albarán ' + albaran, color: '#595959', fontSize: 20, bold: true},
    ], margin: [0, 10, 0, 0]});

    var resumenPesos: any = [
		    [{text: 'Residuo', color: '#595959', fontSize: 11, bold: true}, {text: 'Bruto', color: '#595959', fontSize: 11, bold: true}, {text: 'Tara', color: '#595959', fontSize: 11, bold: true}, {text: 'Neto', color: '#595959', fontSize: 11, bold: true}, {text: 'Clasificado', color: '#595959', fontSize: 11, bold: true}, {text: 'Total', color: '#595959', fontSize: 11, bold: true}],
		];

    /*var numeracion: number = 1;*/
    for(var i=0; i<resumen.length; i++) {
      /*if((i+1) < data.length){
        resumenPesos.push([{text: data[i]['material'], color: '#595959', fontSize: 11, bold: true}, {text: '#'+numeracion+' - '+this.puntuarPeso(data[i]['peso']) + ' Kg', color: '#595959', fontSize: 11, bold: false}, {text: '#'+(numeracion+1)+' - '+this.puntuarPeso(data[i+1]['peso']) + ' Kg', color: '#595959', fontSize: 11, bold: false}, {text: this.diferenciaPesos(data[i]['peso'], data[i+1]['peso']) + ' Kg', color: '#595959', fontSize: 11, bold: true}]);
      }else{
        //resumenPesos.push([{text: data[i]['material'], color: '#595959', fontSize: 11, bold: true}, {text: '#'+numeracion+' - '+this.puntuarPeso(data[i]['peso']) + ' Kg', color: '#595959', fontSize: 11, bold: false}, {text: '-', color: '#595959', fontSize: 11, bold: false}, {text: '-', color: '#595959', fontSize: 11, bold: true}]);
      }
      numeracion++;
      numeracion++;*/
      resumenPesos.push([{text: resumen[i]['residuo'], color: '#595959', fontSize: 11, bold: true}, {text: resumen[i]['peso1'] + 'Kg', color: '#595959', fontSize: 11, bold: false}, {text: resumen[i]['peso2'] + 'Kg', color: '#595959', fontSize: 11, bold: false}, {text: resumen[i]['neto'] + 'Kg', color: '#595959', fontSize: 11, bold: true}, {text: resumen[i]['clasificadoPesoTotal'] + 'Kg', color: '#595959', fontSize: 11, bold: true}, {text: resumen[i]['total'] + 'Kg', color: '#595959', fontSize: 11, bold: true}]);
    }

    bloquesText.push(
      {
        margin: [50, 20, 0, 0], // iz, arrib
        table: {
          widths: ['*', '*', '*', '*', '*', '*'],
          body: resumenPesos,
          fontSize: 15
        },
        layout: {
          hLineWidth: function (i, node) { return 0.50; },
          vLineWidth: function (i, node) { return 0.50; },
          hLineColor: '#0075BD',
          vLineColor: '#0075BD',
          paddingLeft: function(i, node) { return 10; },
          paddingRight: function(i, node) { return 10; },
          paddingTop: function(i, node) { return 7.5; },
          paddingBottom: function(i, node) { return 7.5; },
        },
      }
    );

    // CLASIFICACIÓN
    var clasificacionNumber = 1;
    if(clasificado === true){
      for(var k=0; k<resumen.length; k++) {
        if(resumen[k]['clasificado'].length > 0){
          for(var l=0; l<resumen[k]['clasificado'].length; l++) {
            bloquesText.push(
              {
                text: '',
                pageBreak: "before"
              }
            );

            bloquesText.push({
              columns: [
                {
                  width: 180,
                  image: this.topLogo,
                  alignment : 'center'
                },
                {
                  width: '*',
                  alignment: 'center',
                  text: [
                    {text: 'DOCUMENTO DE BÁSCULA', color: '#0075BD', bold: true, fontSize: 23},
                  ]
                  , margin: [50, 10, 0, 0]
                }
              ]
            });

            bloquesText.push({ text: [
              {text: 'Albarán ' + albaran + ' - Clasificación #' + clasificacionNumber, color: '#595959', fontSize: 20, bold: true},
            ], margin: [0, 10, 0, 0]});

            if((resumen[k]['clasificado'][l]['foto1'].length > 0) && (resumen[k]['clasificado'][l]['foto2'].length > 0)) {
              bloquesText.push(
                {
                  columns: [
                    this.pdfImage(resumen[k]['clasificado'][l]['foto1'], this.pdfPhotoSmallW, this.pdfPhotoSmallH, 'left', [0, 65, 0, 0]),
                    this.pdfImage(resumen[k]['clasificado'][l]['foto2'], this.pdfPhotoSmallW, this.pdfPhotoSmallH, 'right', [0, 65, -10, 0]),
                    {
                      margin: [35, 20, 0, 0], // iz, arrib, right, bottom
                      table: {
                        heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 70],
                        widths: [120, 170],
                        body: [
                          [{text: 'Fecha: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['fecha'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Hora: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['hora'] + ' h', color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Clasificador: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['name'] + ' ' + resumen[k]['clasificado'][l]['surname'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Residuo clasificado: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['residuo'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Residuo encontrado: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['residuo_clasificado'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Peso: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['peso'] + ' Kg', color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Observaciones: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['descripcion'], color: '#595959', fontSize: 11, bold: false}],
                        ],
                        fontSize: 15
                      },
                      layout: {
                        hLineWidth: function (i, node) { return 0.50; },
                        vLineWidth: function (i, node) { return 0.50; },
                        hLineColor: '#0075BD',
                        vLineColor: '#0075BD',
                        paddingLeft: function(i, node) { return 10; },
                        paddingRight: function(i, node) { return 10; },
                        paddingTop: function(i, node) { return 7.5; },
                        paddingBottom: function(i, node) { return 7.5; },
                      },
                    }
                  ],
                }
              );
            }else if((resumen[k]['clasificado'][l]['foto1'].length > 0) && (resumen[k]['clasificado'][l]['foto2'].length === 0)) {
              bloquesText.push(
                this.pdfPhotoTableRow(
                  resumen[k]['clasificado'][l]['foto1'],
                  this.pdfPhotoW,
                  this.pdfPhotoH,
                  this.buildClasificacionTable(resumen[k]['clasificado'][l]),
                ),
              );
            }else {
              bloquesText.push(
                {
                  columns: [
                    {
                      margin: [50, 20, 0, 0], // iz, arrib
                      table: {
                        heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 70],
                        widths: [120, 170],
                        body: [
                          [{text: 'Fecha: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['fecha'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Hora: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['hora'] + ' h', color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Clasificador: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['name'] + ' ' + resumen[k]['clasificado'][l]['surname'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Residuo clasificado: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['residuo'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Residuo encontrado: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['residuo_clasificado'], color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Peso: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['peso'] + ' Kg', color: '#595959', fontSize: 11, bold: false}],
                          [{text: 'Observaciones: ', color: '#595959', fontSize: 11, bold: true}, {text: resumen[k]['clasificado'][l]['descripcion'], color: '#595959', fontSize: 11, bold: false}],
                        ],
                        fontSize: 15
                      },
                      layout: {
                        hLineWidth: function (i, node) { return 0.50; },
                        vLineWidth: function (i, node) { return 0.50; },
                        hLineColor: '#0075BD',
                        vLineColor: '#0075BD',
                        paddingLeft: function(i, node) { return 10; },
                        paddingRight: function(i, node) { return 10; },
                        paddingTop: function(i, node) { return 7.5; },
                        paddingBottom: function(i, node) { return 7.5; },
                      },
                    }
                  ],
                }
              );
            }

            clasificacionNumber++;
          }
        }
      }
    }

    var content = [
      bloquesText,
    ];

    this.pdfmake.downloadPDF(content, 'PesoAlb_'+albaran, albaran, numeroImpresion);
    this.notificationService.openSnackBar("Descargando documento...");
  }

  diferenciaPesos(peso1: string, peso2:string){
    return this.puntuarPeso(Math.abs(parseInt(peso1) - parseInt(peso2)).toString());
  }

  puntuarPeso(peso: string) {
      return peso.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  numSize(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  private pdfBorderlessLayout() {
    return {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    };
  }

  private pdfBlueTableLayout() {
    return {
      hLineWidth: () => 0.50,
      vLineWidth: () => 0.50,
      hLineColor: '#0075BD',
      vLineColor: '#0075BD',
      paddingLeft: () => 10,
      paddingRight: () => 10,
      paddingTop: () => 7.5,
      paddingBottom: () => 7.5,
    };
  }

  private buildPesajeTable(data: any) {
    return {
      table: {
        heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 70],
        widths: [120, 170],
        body: [
          [{text: 'REF. PESO: ', color: '#595959', fontSize: 11, bold: true}, {text: this.numSize(data['id'], 12), color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Fecha: ', color: '#595959', fontSize: 11, bold: true}, {text: data['fecha'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Hora: ', color: '#595959', fontSize: 11, bold: true}, {text: data['hora'] + ' h', color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Matrícula: ', color: '#595959', fontSize: 11, bold: true}, {text: data['matricula'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Chófer: ', color: '#595959', fontSize: 11, bold: true}, {text: data['transportista'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Residuo: ', color: '#595959', fontSize: 11, bold: true}, {text: data['material'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Báscula: ', color: '#595959', fontSize: 11, bold: true}, {text: (data['scale_name'] ? data['scale_name'] : '-'), color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Peso registrado: ', color: '#595959', fontSize: 11, bold: true}, {text: this.puntuarPeso(data['peso']) + ' Kg', color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Observaciones: ', color: '#595959', fontSize: 11, bold: true}, {text: data['descripcion'], color: '#595959', fontSize: 11, bold: false}],
        ],
        fontSize: 15,
      },
      layout: this.pdfBlueTableLayout(),
    };
  }

  private buildClasificacionTable(item: any) {
    return {
      table: {
        heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 70],
        widths: [120, 170],
        body: [
          [{text: 'Fecha: ', color: '#595959', fontSize: 11, bold: true}, {text: item['fecha'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Hora: ', color: '#595959', fontSize: 11, bold: true}, {text: item['hora'] + ' h', color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Clasificador: ', color: '#595959', fontSize: 11, bold: true}, {text: item['name'] + ' ' + item['surname'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Residuo clasificado: ', color: '#595959', fontSize: 11, bold: true}, {text: item['residuo'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Residuo encontrado: ', color: '#595959', fontSize: 11, bold: true}, {text: item['residuo_clasificado'], color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Peso: ', color: '#595959', fontSize: 11, bold: true}, {text: item['peso'] + ' Kg', color: '#595959', fontSize: 11, bold: false}],
          [{text: 'Observaciones: ', color: '#595959', fontSize: 11, bold: true}, {text: item['descripcion'], color: '#595959', fontSize: 11, bold: false}],
        ],
        fontSize: 15,
      },
      layout: this.pdfBlueTableLayout(),
    };
  }

  /**
   * Fila foto + tabla alineadas arriba (pdfmake centra columnas si alturas difieren).
   */
  private pdfPhotoTableRow(
    src: string,
    photoW: number,
    photoH: number,
    tableBlock: { table: any; layout: any },
    tableMarginLeft = 35,
  ) {
    return {
      margin: [0, this.pdfContentTopMargin, 0, 0],
      table: {
        widths: [photoW, '*'],
        body: [[
          {
            border: [false, false, false, false],
            image: src,
            fit: [photoW, photoH],
            alignment: 'center',
          },
          {
            border: [false, false, false, false],
            margin: [tableMarginLeft, 0, 0, 0],
            table: tableBlock.table,
            layout: tableBlock.layout,
          },
        ]],
      },
      layout: this.pdfBorderlessLayout(),
    };
  }

  private pdfImage(
    src: string,
    width: number,
    height: number,
    alignment: 'left' | 'center' | 'right',
    margin: [number, number, number, number],
  ) {
    return {
      width,
      stack: [
        {
          image: src,
          fit: [width, height],
          alignment,
        },
      ],
      margin,
    };
  }

  topLogo: string = "data:image/png;base64,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";

}

/*

1-

bloquesText.push(
  {
    columns: [
      {
        image: data[i]['foto'],
        width: 280,
        alignment : 'center',
        margin: [0, 10, 0, 0]
      },
      {
        table: {
          body: [
            [{text: '\n', border: [false, false, false, false]}, {text: '\n', border: [false, false, false, false] }],
            [{text: 'Fecha: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['fecha'], border: [false, false, false, false] }],
            [{text: 'Hora: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['hora'], border: [false, false, false, false]}],
            [{text: 'Matricula: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['matricula'], border: [false, false, false, false]}],
            [{text: 'Chófer: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['transportista'], border: [false, false, false, false]}],
            [{text: 'Residuo: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['material'], border: [false, false, false, false]}],
            [{text: 'Peso registrado: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['peso'], border: [false, false, false, false]}],
            [{text: 'Observaciones: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['descripcion'], border: [false, false, false, false]}],
          ],
          fontSize: 15
        }
      }
    ]
  }
);




2-

bloquesText.push({
  table: {
    widths: ['auto', '*', 'auto', '*'],
    body: [
      [{text: 'Fecha: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['fecha'], border: [false, false, false, false] }, {text: 'Hora: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['hora'], border: [false, false, false, false]}],
      [{text: 'Matricula: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['matricula'], border: [false, false, false, false]}, {text: 'Chófer: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['transportista'], border: [false, false, false, false]}],
      [{text: 'Residuo: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['material'], border: [false, false, false, false]}, {text: 'Peso registrado: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['peso'] + 'Kg', border: [false, false, false, false]}],
      [{text: 'Observaciones: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['descripcion'], colSpan: 3, border: [false, false, false, false]}],
    ],
    fontSize: 15
  }
});
bloquesText.push({
  image: data[i]['foto'],
  width: 230,
  alignment : 'center',
  margin: [0, 10, 0, 0]
});











3-

var bloquesText = [];
for(var i=0; i<data.length; i++){
  bloquesText.push({ text: [
    {text: 'Pesada ', color: '#006ab1', fontSize: 20},
    {text: '#' + (i+1), fontSize: 20},
  ], margin: [0, 20, 0, 0]});

  bloquesText.push(
    {
      columns: [
        {
          image: data[i]['foto'],
          width: 250,
          alignment : 'center',
          margin: [0, 10, 0, 0]
        },
        {
          table: {
            body: [
              [{text: '\n', border: [false, false, false, false]}, {text: '\n', border: [false, false, false, false] }],
              [{text: 'Fecha: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['fecha'], border: [false, false, false, false] }],
              [{text: 'Hora: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['hora'], border: [false, false, false, false]}],
              [{text: 'Matricula: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['matricula'], border: [false, false, false, false]}],
              [{text: 'Chófer: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['transportista'], border: [false, false, false, false]}],
              [{text: 'Residuo: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['material'], border: [false, false, false, false]}],
              [{text: 'Peso registrado: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['peso'] + ' Kg', border: [false, false, false, false]}],
              [{text: 'Observaciones: ', color: '#006ab1', border: [false, false, false, false]}, {text: data[i]['descripcion'], border: [false, false, false, false]}],
            ],
            fontSize: 15
          }
        }
      ]
    }
  );
}

var content = [
  {
    columns: [
      {
        width: 100,
        image: this.logoRet,
        alignment : 'center'
      },
      {
        width: '*',
        alignment: 'center',
        text: [
          {text: '\n'},
          {text: 'DOCUMENTO DE BÁSCULA\n', fontSize: 20},
          {text: 'Albarán ', color: '#006ab1', fontSize: 20},
          {text: albaran, fontSize: 20},
        ]
      },
      {
        width: 80,
        image: this.isoRet,
        alignment : 'center'
      },
    ]
  },
  bloquesText,
  { text: 'Recollida, Eliminació i Tractament de Residus, S.L.U.   |   ES B60526621', alignment: 'center', fontSize: 10, margin: [0, 50, 0, 0], color: '#b3b3b3'  },
  { text: '938 449 012   |   info@retsl.com   |   www.retsl.com', alignment: 'center', fontSize: 10, color: '#b3b3b3' },
  { text: 'C/ Carles Buïgas nº 3-5, Pol. Ind. Can Magre, Santa Eulàlia de Ronçana, 08187, Barcelona', alignment: 'center', fontSize: 10, color: '#b3b3b3'  },
];


var content = [
  bloquesText,
  { text: 'Recollida, Eliminació i Tractament de Residus, S.L.U.   |   ES B60526621', alignment: 'center', fontSize: 10, margin: [0, 50, 0, 0], color: '#b3b3b3'  },
  { text: '938 449 012   |   info@retsl.com   |   www.retsl.com', alignment: 'center', fontSize: 10, color: '#b3b3b3' },
  { text: 'C/ Carles Buïgas nº 3-5, Pol. Ind. Can Magre, Santa Eulàlia de Ronçana, 08187, Barcelona', alignment: 'center', fontSize: 10, color: '#b3b3b3'  },
];


*/
